import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ListAuditoriaComponent} from './cmp-list-auditoria/list-auditoria.component';
import {FormAuditoriaComponent} from './cmp-form-auditoria/form-auditoria.component';


import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {LoadingModule} from "../../../../autenticacion/loadingScreen/loading.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        LoadingModule
    ],
    declarations: [ListAuditoriaComponent, FormAuditoriaComponent]
})
export class AuditoriaModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/auditoria/auditoria.module.ts